import apiClient from './apiClient';
import { BusinessHoursConfig, BusinessHoursCheck, BusinessHoursFormData } from '../types/businessHours.types';

export const businessHoursService = {
  // Obter configuração de horário comercial
  async getBusinessHours(botId: number): Promise<BusinessHoursConfig> {
    const response = await apiClient.get(`/bots/${botId}/business-hours`);
    return response.data.data;
  },

  // Salvar configuração de horário comercial
  async saveBusinessHours(botId: number, data: BusinessHoursFormData): Promise<BusinessHoursConfig> {
    const response = await apiClient.post(`/bots/${botId}/business-hours`, data);
    return response.data.data;
  },

  // Verificar se está dentro do horário comercial
  async checkBusinessHours(botId: number): Promise<BusinessHoursCheck> {
    const response = await apiClient.get(`/bots/${botId}/business-hours/check`);
    return response.data.data;
  }
};

